import { useEffect } from 'react';
import { toList, useApiQuery } from '../useApiQuery';

export interface ExportField {
    code: string;
    label: string;
}

interface ApiExportField {
    querySegmentFieldsId: number;
    exportField: boolean;
    isExportField: boolean;
    label: string;
    name: string;
}

const NO_FIELDS: ExportField[] = [];

const toExportFields = (raw: unknown): ExportField[] => toList<ApiExportField>(raw)
    .filter(field => field.name && field.isExportField !== false && field.exportField !== false)
    .map(field => ({ code: field.name, label: field.label || field.name }));

export const useExportFields = () => {
    const { data, isLoading, error, fetch } = useApiQuery<ExportField[]>('/getExportFields', {
        withWorkspace: false,
        initialData: NO_FIELDS,
        transform: toExportFields,
        defaultError: 'Erreur lors du chargement des champs exportables',
    });

    useEffect(() => {
        fetch();
    }, [fetch]);

    return { fields: data, loading: isLoading || (data === NO_FIELDS && !error), error };
};
